import { render, staticRenderFns } from "./profile-theme.component.vue?vue&type=template&id=56a1b2ad&scoped=true&"
import script from "./profile-theme.component.ts?vue&type=script&lang=ts&"
export * from "./profile-theme.component.ts?vue&type=script&lang=ts&"
import style0 from "./profile-theme.component.scss?vue&type=style&index=0&id=56a1b2ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a1b2ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
